const mapCarolineContentAccess = () => ({ status: 'available', canAccess: true });

module.exports = mapCarolineContentAccess;
